var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('record-info',{attrs:{"noHiding":true}}),_c('snackbar-notifier'),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }